import { DOMUtils } from '../../../../utils/dom'
import { GtmEvent } from '../../../common/events/gtm'
import { IdentityEvent } from '../../../common/events/identity'

declare let window: any
const DEFAULT_DATALAYER_NAME = 'dataLayer'

interface IGTMEvent {
    event_type?: string
    [key: string]: string
}
export class GTM {
    private dataLayerName: string

    public constructor( dataLayerName = DEFAULT_DATALAYER_NAME) {
        this.dataLayerName= dataLayerName
    }

    /**
     * Initialize Google Tag Manager
     */
    public init(account: string, auth?: string, env?: string): void {
        if(this.dataLayerName !== DEFAULT_DATALAYER_NAME) {
            // send mp_id to gtm
            addEventListener(IdentityEvent.MP_READY, (e: any) => {
                const eventData: IGTMEvent= {}
                if (e.detail.mpId) {
                    eventData.mp_id = e.detail.mpId
                }
                if(e.detail.mpSessionUuid) {
                    eventData.session_uuid = e.detail.mpSessionUuid
                }
                this.sendEvent(eventData)
            })

            // send page view and load JS script
            addEventListener(GtmEvent.FIRE_PAGE_VIEW, (e: CustomEvent) => {
                this.sendEvent(e.detail)
                this.loadScript(account, auth, env)
            })
        } else {
            this.loadScript(account, auth, env)
        }
    }

    // send events with attributes to GTM
    public sendEvent(dataAttrs: IGTMEvent) {
        const {...evtAttrs} = dataAttrs
        window[this.dataLayerName]=window[this.dataLayerName]||[]
        window[this.dataLayerName].push({
            ...evtAttrs
        })
    }
    /**
     * load gtm script
     * @param account:string
     * @param auth:string
     * @param env:string
     */
    private loadScript(account: string, auth: string, env: string): void {
        window[this.dataLayerName]=window[this.dataLayerName]||[]
        window[this.dataLayerName].push(
            {
                'event':'gtm.js',
                'gtm.start': new Date().getTime()
            }
        )
        let extraParams = ''
        if( auth ) {
            extraParams+= '&gtm_auth='+auth
        }
        if( env ) {
            extraParams += '&gtm_preview='+ env
        }
        DOMUtils.loadScript(`//www.googletagmanager.com/gtm.js?id=${account}&l=${this.dataLayerName}${extraParams}`)
    }
}
